/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/button-has-type */
import React, { Component } from 'react';
import NaijaStates from 'naija-state-local-government';
import { connect } from 'react-redux';
import isEmpty from 'is-empty';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import UserDashBoardSideNavigation from
  '../../dashboard.components/userDashBoard.components/UserDashBoardSideNavigation';
import UserDashBoardTopNavigation from
  '../../dashboard.components/userDashBoard.components/UserDashBoardTopNavigation';
import DashboardMobileNav from '../../navigation.components/DashboardMobileNav';
import {
  kycValidateInput,
  kycValidateInputPersonal,
  kycValidateInputAddress,
  kycUploadInput,
} from '../../../middlewares/validateKycInput';
import {
  TextField,
  ErrorAlertNotification,
} from '../../commons/index';
import uploadPersonalSavingImg, { deleteUploadImg } from '../../../actions/image.actions/personalSavingImg';
import uploadTaxClearanceImg, { deleteTaxClearanceUploadImg } from '../../../actions/image.actions/taxClearanceImg';
import uploadSignatureImg, { deleteSigUrlUploadImg } from '../../../actions/image.actions/signatureImg';
import postKycRequest, { deleteKycError } from '../../../actions/kyc.actions/kyc.action';

/**
 * @class KycComponent
 * @param {*} event
 */
class KycComponent extends Component {
  state = {
    nationality: 'Nationality',
    stateOfOrigin: 'state',
    localGovernmentArea: '',
    gender: '',
    maritalStatus: '',
    mothersMaidenName: '',
    residentialAddress: '',
    contactAddress: '',
    countryOfResidence: '',
    meansOfIdentificationURL: '',
    electronicTaxClearanceCertificate: '',
    employmentStatus: '',
    nextOfKin: '',
    addressOfNextOfKin: '',
    emailOfNextOfKin: '',
    phoneNumberOfNextOfKin: '',
    signatureURL: '',
    state: '',
    error: {},
    firstName: '',
    lastName: '',
    step1: true,
    step2: false,
    step3: false,
    step4: false,
  }

  /**
   *
   * @param {*} props
   * @param {*} state
   * @returns {*} - state
   */
  static getDerivedStateFromProps(props, state) {
    return props.savingImg !== state.meansOfIdentificationURL || props.taxClearanceSavingImg !== state.electronicTaxClearanceCertificate || props.signatureSavingImg !== state.signatureURL ? {
      meansOfIdentificationURL: props.savingImg,
      electronicTaxClearanceCertificate: props.taxClearanceSavingImg,
      signatureURL: props.signatureSavingImg
    } : null;
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  onChange = (event) => {
    const { errors } = this.state;
    if (errors === undefined) {
      this.setState({
        [event.target.name]: event.target.value,
      });
      return errors;
    } else if (errors[event.target.name]) {
      delete errors[event.target.name];
      this.setState({
        [event.target.name]: event.target.value,
      });
    } else {
      this.setState({
        [event.target.name]: event.target.value,
      });
    }
  }

  /**
  *
  *@param {*} event
  *@returns {*} - state
  */
 onFirstPhase = (event) => {
   event.preventDefault();
   if (this.isValidFirstPhase()) {
     this.setState({
       errors: {},
       step1: false,
       step2: true
     });
   }
 }

 /**
  *
  *@param {*} event
  *@returns {*} - state
  */
 onSecondPhase = (event) => {
   event.preventDefault();
   if (this.isValidSecondPhase()) {
     this.setState({
       errors: {},
       step2: false,
       step3: true
     });
   }
 }

 /**
  *
  *@param {*} event
  *@returns {*} - state
  */
 onThirdPhase = (event) => {
   event.preventDefault();
   if (this.isValidThirdPhase()) {
     this.setState({
       errors: {},
       step3: false,
       step4: true
     });
   }
 }

 /**
  *
  *@param {*} event
  *@returns {*} - state
  */
 keyPressed = (event) => {
   if (event.key === 'Enter') {
     this.onSubmit();
   }
 }

 /**
  *
  *@param {*} event
  *@returns {*} - state
  */
 onSubmit = () => {
   const {
     nationality,
     stateOfOrigin,
     localGovernmentArea,
     gender,
     maritalStatus,
     mothersMaidenName,
     residentialAddress,
     contactAddress,
     countryOfResidence,
     meansOfIdentificationURL,
     electronicTaxClearanceCertificate,
     employmentStatus,
     addressOfNextOfKin,
     emailOfNextOfKin,
     phoneNumberOfNextOfKin,
     signatureURL,
     firstName,
     lastName
   } = this.state;

   const { PostKycRequest } = this.props;

   const mainObj = {
     nationality,
     stateOfOrigin,
     localGovernmentArea,
     gender,
     maritalStatus,
     mothersMaidenName,
     residentialAddress,
     contactAddress,
     countryOfResidence,
     meansOfIdentificationURL,
     electronicTaxClearanceCertificate,
     employmentStatus,
     nextOfKin: `${firstName} ${lastName}`,
     addressOfNextOfKin,
     emailOfNextOfKin,
     phoneNumberOfNextOfKin,
     signatureURL,
   };
   if (this.isValid()) {
     PostKycRequest(mainObj);
     this.setState({ errors: {} });
   }
 }

 /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  fileSelectHandler = (event) => {
    const { UploadPersonalSavingImg, savingImg } = this.props;

    this.setState({
      meansOfIdentificationURL: event.target.files[0]
    });
    UploadPersonalSavingImg(event.target.files[0]).then(() => {
      this.setState({ meansOfIdentificationURL: savingImg });
    });
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  fileSelectHandlerTwo = (event) => {
    const { UploadTaxClearanceImg, taxClearanceSavingImg } = this.props;
    this.setState({
      electronicTaxClearanceCertificate: event.target.files[0]
    });
    UploadTaxClearanceImg(event.target.files[0]).then(() => {
      this.setState({ electronicTaxClearanceCertificate: taxClearanceSavingImg });
    });
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  fileSelectHandlerThree = (event) => {
    const { UploadSignatureImg, signatureSavingImg } = this.props;
    if (signatureSavingImg) {
      this.setState({
        signatureURL: signatureSavingImg
      });
    } else {
      this.setState({
        signatureURL: event.target.files[0]
      });
      UploadSignatureImg(event.target.files[0]).then(() => {
        this.setState({ signatureURL: signatureSavingImg });
      });
    }
  }

  /**
   *
   * @returns {*} - state
   */
  handleDelete = () => {
    const {
      DeleteUploadImg,
      DeleteTaxClearanceUploadImg,
      DeleteSigUrlUploadImg,
      meansOfIdError,
      taxClearanceError,
      signatureError,
      mainKycError,
      DeleteKycError
    } = this.props;
    if (meansOfIdError) {
      DeleteUploadImg();
    }
    if (taxClearanceError) {
      DeleteTaxClearanceUploadImg();
    }
    if (signatureError) {
      DeleteSigUrlUploadImg();
    }
    if (mainKycError) {
      DeleteKycError();
    }
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  isValidFirstPhase = () => {
    const { errors, isValid } = kycValidateInputPersonal(
      this.state
    );
    if (!isValid) {
      this.setState({
        errors
      });
    }
    return isValid;
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  isValidSecondPhase = () => {
    const { errors, isValid } = kycValidateInputAddress(
      this.state
    );
    if (!isValid) {
      this.setState({
        errors
      });
    }
    return isValid;
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  isValidThirdPhase = () => {
    const { errors, isValid } = kycUploadInput(
      this.state
    );
    if (!isValid) {
      this.setState({
        errors
      });
    }
    return isValid;
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  isValid = () => {
    const { errors, isValid } = kycValidateInput(
      this.state
    );
    if (!isValid) {
      this.setState({
        errors
      });
    }
    return isValid;
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const {
      errors,
      stateOfOrigin,
      localGovernmentArea,
      gender,
      employmentStatus,
      maritalStatus,
      nationality,
      mothersMaidenName,
      residentialAddress,
      contactAddress,
      countryOfResidence,
      firstName,
      lastName,
      emailOfNextOfKin,
      phoneNumberOfNextOfKin,
      addressOfNextOfKin,
      step1,
      step2,
      step3,
      step4,
    } = this.state;

    const {
      imgLoading,
      savingImg,
      taxImgLoading,
      taxClearanceSavingImg,
      sigImgLoading,
      signatureSavingImg,
      meansOfIdError,
      taxClearanceError,
      signatureError,
      kycLoading,
      mainKycError,
      history
    } = this.props;

    const country = ['Nationality', 'Nigeria'];
    const naijaState = NaijaStates.states();

    naijaState.splice(0, 0, 'Select a state');

    const naijaLGA = NaijaStates.lgas(stateOfOrigin);

    const userGender = ['Gender', 'Male', 'Female'];

    const userEmploymentStatus = ['Employment Status', 'Employed', 'Self-employed', 'Unemployed'];

    const userMaritalStatus = ['Marital status', 'Single', 'Married', 'Divorce', 'Separated'];

    const kycForms = (
      <section className="body_space ">
        <div className="go_back">
          <span onClick={history.goBack}>
            <i className="fa fa-arrow-left" aria-hidden="true" /> 
{' '}
{'  '}
             Go Back
          </span>
        </div>
        <div className="my_account_wrapper">
          <div className="my_account">
            <div className="acct_title">
              <h3>
                Set Up Your KYC
              </h3>
            </div>

            <div className="acc_stages_scroll">
              <div className="acct_stages">
                <div className={step1 ? 'active' : ''}
                  // id="acct_sett"
                  onClick={this.onFirstPhase}
                >
                  <span>
              Personal Information
                  </span>
                </div>
                <div className={step2 ? 'active' : ''}
                  // id="acct_pass"
                  onClick={this.onFirstPhase}
                >
                  <span>
                            Address
                  </span>
                </div>
                <div
                  className={step3 ? 'active' : ''}
                  // id="acct_docs"
                  onClick={this.onSecondPhase}
                >
                  <span>
                    Documents
                  </span>
                </div>
                <div
                  className={step4 ? 'active' : ''}
                  onClick={this.onThirdPhase}
                >
                  <span>
                    Next of Kin
                  </span>
                </div>
              </div>
            </div>

            <div className="my_account_content">

              {/* ========================= start of personal account ============================== */}
              {
                step1 ? (
                  <>
                    <div className="text-center mb-5">
                      <h6>
                        {' '}
Please Note all fields with
                        {' '}
                        {' '}
                        <span style={{ color: 'red' }}>*</span>
                        {' '}
                        {' '}
                  are required.
                      </h6>
                    </div>
                    <div className="container acc_cont" id="account_sett_acct">
                      <div className="row py-2">
                        <div className="col-md-5 acc_descs">

                          <h3>
                       Nationality
                            {' '}
                            <span style={{ color: 'red' }}>*</span>
                          </h3>
                          <span>
                      Kindly choose a country where you are from.
                          </span>

                        </div>
                        <div className="col-md-7">

                          <div className="input_div">
                            <select
                              name="nationality"
                              id="savingFrequencyOption"
                              onChange={this.onChange}
                              value={nationality}
                            >
                              {
                        country.map((nation, index) => (
                          <option key={index} value={nation}>
                            {nation}
                          </option>
                        ))
                      }
                            </select>
                            {
                          errors === undefined ? '' : (
                            <p className="text-danger">
                              {' '}
                              {errors.nationality}
                            </p>
                          )
                        }
                          </div>
                        </div>
                      </div>

                      <div className="row py-2">
                        <div className="col-md-5 acc_descs">

                          <h3>
                      State of Origin
                            {' '}
                            <span style={{ color: 'red' }}>*</span>
                          </h3>
                          <span>
                      Choose a state of origin
                          </span>

                        </div>
                        <div className="col-md-7">

                          <div className="row">
                            <div className="col-md-6">
                              <div className="input_div">
                                <select
                                  name="stateOfOrigin"
                                  id="savingFrequencyOption"
                                  onChange={this.onChange}
                                  value={stateOfOrigin}
                                >
                                  {
                              naijaState.map((i, index) => (
                                <option key={index} value={i}>
                                  {i}
                                </option>
                              ))
                            }
                                </select>
                                {
                          errors === undefined ? '' : (
                            <p className="text-danger">
                              {' '}
                              {errors.stateOfOrigin}
                            </p>
                          )
                        }
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="input_div">
                                <select
                                  name="localGovernmentArea"
                                  id="savingFrequencyOption"
                                  onChange={this.onChange}
                                  value={localGovernmentArea}
                                >
                                  {
                              naijaLGA === undefined ? (
                                <option>
                                  Local Government
                                </option>
                              )
                                : naijaLGA.lgas.map((lga, index) => (
                                  <option key={index} value={lga}>
                                    {lga}
                                  </option>
                                ))
                            }
                                </select>
                                {
                          errors === undefined ? '' : (
                            <p className="text-danger">
                              {' '}
                              {errors.localGovernmentArea}
                            </p>
                          )
                        }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row py-2">
                        <div className="col-md-5 acc_descs">

                          <h3>
                      Gender
                            {' '}
                            <span style={{ color: 'red' }}>*</span>
                          </h3>
                          <span>
                      Choose a gender
                          </span>

                        </div>
                        <div className="col-md-7">

                          <div className="input_div">
                            <select
                              name="gender"
                              onChange={this.onChange}
                              value={gender}
                              id="savingFrequencyOption"
                            >
                              {
                          userGender.map((myGender, index) => (
                            <option key={index} value={myGender}>
                              {myGender}
                            </option>
                          ))
                        }
                            </select>
                            {
                          errors === undefined ? '' : (
                            <p className="text-danger">
                              {' '}
                              {errors.gender}
                            </p>
                          )
                        }
                          </div>
                        </div>
                      </div>

                      <div className="row py-2">
                        <div className="col-md-5 acc_descs">

                          <h3>

                  Employment status
                            {' '}
                            <span style={{ color: 'red' }}>*</span>
                          </h3>
                          <span>
                  What is your Employment status?
                          </span>

                        </div>
                        <div className="col-md-7">

                          <div className="row">
                            <div className="col-md-12">
                              <div className="input_div">
                                <select
                                  name="employmentStatus"
                                  id="savingFrequencyOption"
                                  value={employmentStatus}
                                  onChange={this.onChange}
                                >
                                  {
                              userEmploymentStatus.map((employeeStat, index) => (
                                <option key={index} value={employeeStat}>
                                  {employeeStat}
                                </option>
                              ))
                            }
                                </select>
                                {
                          errors === undefined ? '' : (
                            <p className="text-danger">
                              {' '}
                              {errors.employmentStatus}
                            </p>
                          )
                        }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row py-2">
                        <div className="col-md-5 acc_descs">

                          <h3>
                  Marital Status
                            {' '}
                            <span style={{ color: 'red' }}>*</span>
                          </h3>
                          <span>
                      Choose your marital status
                          </span>

                        </div>
                        <div className="col-md-7">

                          <div className="row">
                            <div className="col-md-12">
                              <div className="input_div">
                                <select
                                  name="maritalStatus"
                                  id="savingFrequencyOption"
                                  onChange={this.onChange}
                                  value={maritalStatus}
                                >
                                  {
                              userMaritalStatus.map((status, index) => (
                                <option key={index} value={status}>
                                  {status}
                                </option>
                              ))
                            }
                                </select>
                                {
                          errors === undefined ? '' : (
                            <p className="text-danger">
                              {' '}
                              {errors.maritalStatus}
                            </p>
                          )
                        }
                              </div>

                            </div>
                          </div>

                        </div>
                      </div>

                      <div className="row py-2">
                        <div className="col-md-5 acc_descs">

                          <h3>
                  Mother Maiden Name
                            {' '}
                            <span style={{ color: 'red' }}>*</span>
                          </h3>
                          <span>
                  Enter your mother Maiden name
                          </span>

                        </div>
                        <div className="col-md-7">

                          <div className="input_div">
                            <TextField
                              error={errors === undefined ? '' : errors.mothersMaidenName}
                              type="text"
                              field="mothersMaidenName"
                              value={mothersMaidenName}
                              onChange={this.onChange}
                              placeholder="Mother Maiden Name"
                              onKeyPress={this.keyPressed}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12">
                          <div className="acct_btn">
                            <button
                              type="button"
                              onClick={this.onFirstPhase}
                              onKeyPress={this.keyPressed}
                            >
                    Next
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : ''
              }

              {/* ========================================== Contact Information ================================== */}
              {
                step2 ? (
                  <>
                    <div className="text-center mb-5">
                      <h6>
                        {' '}
Please Note all fields with
                        {' '}
                        {' '}
                        <span style={{ color: 'red' }}>*</span>
                        {' '}
                        {' '}
                  are required.
                      </h6>
                    </div>
                    <div className="container change_pass" id="account_sett_change_pass">
                      <div className="row">
                        <div className="col-md-5 acc_descs">
                          <h3>
                      Contact address
                            {' '}
                            <span style={{ color: 'red' }}>*</span>
                          </h3>
                          <span>
                      Enter your Contact address
                          </span>
                        </div>
                        <div className="col-md-7">
                          <div className="row">
                            <div className="col-md-12 mb-1">
                              <div className="input_div">
                                <TextField
                                  error={errors === undefined ? '' : errors.contactAddress}
                                  type="text"
                                  field="contactAddress"
                                  value={contactAddress}
                                  onChange={this.onChange}
                                  placeholder="Contact address"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-5 acc_descs">
                          <h3>
                      Country of Residence
                            {' '}
                            <span style={{ color: 'red' }}>*</span>
                          </h3>
                          <span>
                      Enter your Country of Residence
                          </span>
                        </div>
                        <div className="col-md-7">

                          <div className="row">
                            <div className="col-md-12 mb-1">
                              <div className="input_div">
                                <TextField
                                  error={errors === undefined ? '' : errors.countryOfResidence}
                                  type="text"
                                  field="countryOfResidence"
                                  value={countryOfResidence}
                                  onChange={this.onChange}
                                  placeholder="Country of Residence"
                                />
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-5 acc_descs">
                          <h3>
                      Residential Address
                            {' '}
                            <span style={{ color: 'red' }}>*</span>
                          </h3>
                          <span>
                      Enter your Residential Address
                          </span>
                        </div>
                        <div className="col-md-7">

                          <div className="row">
                            <div className="col-md-12 mb-1">
                              <div className="input_div">
                                <TextField
                                  error={errors === undefined ? '' : errors.residentialAddress}
                                  onChange={this.onChange}
                                  type="text"
                                  field="residentialAddress"
                                  value={residentialAddress}
                                  placeholder="Residential Address"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12">
                          <div className="acct_btn">
                            <button
                              type="button"
                              id="goto_settins_documents"
                              onClick={this.onSecondPhase}
                            >
                        Next
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : ''
              }

              {/* =========================== Upload documents ================================ */}

              {
                step3 ? (
                  <>
                    <div className="text-center mb-5">
                      <h6>
                        {' '}
Please Note all fields with
                        {' '}
                        {' '}
                        <span style={{ color: 'red' }}>*</span>
                        {' '}
                        {' '}
                  are required.
                      </h6>
                    </div>
                    <div className="container documents" id="account_sett_docs">
                      <div className="d-flex align-items-center flex-column">
                        {
                  meansOfIdError || taxClearanceError || signatureError ? (
                    <ErrorAlertNotification
                      errors={meansOfIdError || taxClearanceError || signatureError}
                      onClick={this.handleDelete}
                    />
                  ) : ''
                }
                        {errors && <p className="text-danger">{errors.meansOfIdentification}</p>}
                        <div className="col-md-5 mx-auto mb-4 col-offset-7">
                          <div className="d-flex flex-row align-items-center justify-content-between each_docs">
                            {
                      savingImg ? (
                        <div>
                          <img className="kyc_doc_image" src={
                                  savingImg
                                  }
                            alt=""

                          />
                        </div>
                      ) : (
                        <div className="kyc_doc_image" />
                      )
                    }
                            <div>
                              <h6>
                          Means Of Identification
                              </h6>
                              <span>
                          Driver License / National ID /
                                {' '}
                                <br />
                                {' '}
PVC / National Passport
                                {' '}
                                <br />
                              </span>
                              <span>
                          JPG, PNG ( Less than 5mb)
                              </span>
                            </div>
                            {
                        imgLoading
                          ? (
                            <div className="choose_file">
                              <button type="button">
                                <i className="fa fa-spinner fa-spin" />
                                {'  '}
                                <i className="fas fa-file-upload" />
                                {' '}
                          Upload
                              </button>
                            </div>
                          ) : (
                            <div className="choose_file">
                              <button type="button">
                                <i className="fas fa-file-upload" />
                                {' '}
                          Upload
                              </button>
                              <input
                                type="file"
                                name="img"
                                accept="image/*"
                                onChange={this.fileSelectHandler}
                              />
                            </div>
                          )
                      }

                          </div>
                        </div>
                        {errors && <p className="text-danger">{errors.electronicTaxClearanceCertificate}</p>}
                        <div className="col-md-5 mx-auto mb-4 col-offset-7 ">
                          <div className="d-flex flex-row align-items-center justify-content-between each_docs">
                            {
                      taxClearanceSavingImg ? (
                        <div>
                          <img className="kyc_doc_image" src={
                                  taxClearanceSavingImg
                                  }
                            alt=""

                          />
                        </div>
                      ) : (
                        <div className="kyc_doc_image" />
                      )
                    }
                            <div>
                              <h6>
                          Electronic Tax Clearance Certificate
                              </h6>
                              <span>
                          JPG, PNG ( Less than 5mb)
                              </span>
                            </div>
                            {
                        taxImgLoading
                          ? (
                            <div className="choose_file">
                              <button type="button">
                                <i className="fa fa-spinner fa-spin" />
                                {'  '}
                                <i className="fas fa-file-upload" />
                                {' '}
                          Upload
                              </button>
                            </div>
                          ) : (
                            <div className="choose_file">
                              <button type="button">
                                <i className="fas fa-file-upload" />
                                {' '}
                          Upload
                              </button>
                              <input
                                type="file"
                                name="img"
                                accept="image/*"
                                onChange={this.fileSelectHandlerTwo}
                              />
                            </div>
                          )
                      }
                          </div>
                        </div>
                        {errors && <p className="text-danger">{errors.signatureURL}</p>}
                        <div className="col-md-5 mx-auto mb-4 col-offset-7">
                          <div className="d-flex flex-row align-items-center justify-content-between each_docs">
                            {
                      signatureSavingImg ? (
                        <div>
                          <img className="kyc_doc_image" src={
                                  signatureSavingImg
                                  }
                            alt=""

                          />
                        </div>
                      ) : (
                        <div className="kyc_doc_image" />
                      )
                    }

                            <div>
                              <h6>
                          Your signature
                              </h6>
                              <span>
                          JPG, PNG ( Less than 5mb)
                              </span>
                            </div>
                            {
                        sigImgLoading
                          ? (
                            <div className="choose_file">
                              <button type="button">
                                <i className="fa fa-spinner fa-spin" />
                                {'  '}
                                <i className="fas fa-file-upload" />
                                {' '}
                          Upload
                              </button>
                            </div>
                          ) : (
                            <div className="choose_file">
                              <button type="button">
                                <i className="fas fa-file-upload" />
                                {' '}
                          Upload
                              </button>
                              <input
                                type="file"
                                name="img"
                                accept="image/*"
                                onChange={this.fileSelectHandlerThree}
                              />
                            </div>
                          )
                      }
                          </div>
                        </div>
                      </div>

                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div className="acct_btn text-center">
                            <button
                              id="goto_settins_kin"
                              onClick={this.onThirdPhase}
                            >
                        Next
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : ''
              }

              {/* ============================= Next of Kin Information =========================================== */}
              {
                step4 ? (
                  <>
                    <div className="text-center mb-5">
                      <h6>
                        {' '}
Please Note all fields with
                        {' '}
                        {' '}
                        <span style={{ color: 'red' }}>*</span>
                        {' '}
                        {' '}
                  are required.
                      </h6>
                    </div>
                    <div className="container next_of_kin" id="account_sett_kin">
                      <div className="row py-2">
                        {
                      mainKycError ? (
                        <ErrorAlertNotification
                          errors={mainKycError}
                          onClick={this.handleDelete}
                        />
                      ) : ''
                    }
                        <div className="col-md-5 acc_descs">
                          <h3>
                      Enter Full Name
                            {' '}
                            <span style={{ color: 'red' }}>*</span>
                          </h3>
                          <span>
                      Enter your next of Kin full name
                          </span>
                        </div>
                        <div className="col-md-7">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="input_div">
                                <TextField
                                  error={errors === undefined ? '' : errors.firstName}
                                  type="text"
                                  onChange={this.onChange}
                                  field="firstName"
                                  value={firstName}
                                  placeholder="First Name"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="input_div">
                                <TextField
                                  error={errors === undefined ? '' : errors.lastName}
                                  type="text"
                                  onChange={this.onChange}
                                  field="lastName"
                                  value={lastName}
                                  placeholder="Last Name"
                                />
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                      <div className="row py-2">
                        <div className="col-md-5 acc_descs">
                          <h3>
                      Email Address
                            {' '}
                            <span style={{ color: 'red' }}>*</span>
                          </h3>
                          <span>
                      We send saving notifications and other account
                            {' '}
                            <br />
                            {' '}
updates to your confirmed email address
                          </span>
                        </div>
                        <div className="col-md-7">
                          <div className="input_div">
                            <TextField
                              error={errors === undefined ? '' : errors.emailOfNextOfKin}
                              type="text"
                              onChange={this.onChange}
                              field="emailOfNextOfKin"
                              value={emailOfNextOfKin}
                              placeholder="Next of Kin Email"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row py-2">
                        <div className="col-md-5 acc_descs">

                          <h3>
                      Phone Number
                            {' '}
                            <span style={{ color: 'red' }}>*</span>
                          </h3>
                          <span>
                      We send sms verification messages to your
                            {' '}
                            <br />
                            {' '}
phone number
                          </span>
                        </div>
                        <div className="col-md-7">
                          <div className="input_div">
                            <TextField
                              error={errors === undefined ? '' : errors.phoneNumberOfNextOfKin}
                              type="text"
                              onChange={this.onChange}
                              field="phoneNumberOfNextOfKin"
                              value={phoneNumberOfNextOfKin}
                              placeholder="Next of Kin Phone Number"
                            />
                          </div>

                        </div>
                      </div>

                      <div className="row py-2">
                        <div className="col-md-5 acc_descs">

                          <h3>
                      Address
                            {' '}
                            <span style={{ color: 'red' }}>*</span>
                          </h3>
                          <span>
                      Enter your next of kin address
                          </span>
                        </div>
                        <div className="col-md-7">
                          <div className="input_div">
                            <TextField
                              error={errors === undefined ? '' : errors.addressOfNextOfKin}
                              type="text"
                              onChange={this.onChange}
                              field="addressOfNextOfKin"
                              value={addressOfNextOfKin}
                              placeholder="Next of Kin Address"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12">
                          {
                        kycLoading ? (
                          <div className="acct_btn">
                            <button
                              type="button"
                              onClick={this.onSubmit}
                            >
                              <i className="fa fa-spinner fa-spin" />
                              {'  '}
                        Save My Information
                            </button>
                          </div>
                        ) : (
                          <div className="acct_btn">
                            <button
                              type="button"
                              onClick={this.onSubmit}
                            >
                        Save My Information
                            </button>
                          </div>
                        )
                      }

                        </div>
                      </div>
                    </div>
                  </>
                ) : ''
              }
            </div>

          </div>
        </div>
      </section>
    );
    return (
      <>
        <DashboardMobileNav />
        <UserDashBoardSideNavigation />
        <div className="main_body_wrapper">
          <UserDashBoardTopNavigation />
          {kycForms}
        </div>
      </>
    );
  }
}

KycComponent.propTypes = {
  UploadPersonalSavingImg: PropTypes.func,
  savingImg: PropTypes.string,
  imgLoading: PropTypes.bool,
  taxImgLoading: PropTypes.bool,
  taxClearanceSavingImg: PropTypes.string,
  sigImgLoading: PropTypes.bool,
  signatureSavingImg: PropTypes.string,
  meansOfIdError: PropTypes.string,
  taxClearanceError: PropTypes.string,
  signatureError: PropTypes.string,
  DeleteUploadImg: PropTypes.func,
  DeleteTaxClearanceUploadImg: PropTypes.func,
  DeleteSigUrlUploadImg: PropTypes.func,
  PostKycRequest: PropTypes.func,
  UploadTaxClearanceImg: PropTypes.string,
  UploadSignatureImg: PropTypes.string,
  mainKycError: PropTypes.string,
  DeleteKycError: PropTypes.string,
  kycLoading: PropTypes.bool,
};

const mapStateToProps = state => ({
  savingImg: isEmpty(state.personalSavingImage) ? '' : state.personalSavingImage.photo,
  taxClearanceSavingImg: isEmpty(state.uploadTaxClearanceImg) ? '' : state.uploadTaxClearanceImg.photo,

  signatureSavingImg: isEmpty(state.signatureImg) ? '' : state.signatureImg.photo,

  imgLoading: state.personalSavingImage.imgLoading,
  taxImgLoading: state.uploadTaxClearanceImg.imgLoading,
  sigImgLoading: state.signatureImg.imgLoading,
  kycLoading: state.kyc.kycLoading,


  imgSuccess: state.personalSavingImage.success,
  taxImgSuccess: state.uploadTaxClearanceImg.success,
  sigImgSuccess: state.signatureImg.success,

  meansOfIdError: state.personalSavingImage.error,
  taxClearanceError: state.uploadTaxClearanceImg.error,
  signatureError: state.signatureImg.error,
  mainKycError: state.kyc.error,
});

export default withRouter(connect(mapStateToProps, {
  UploadPersonalSavingImg: uploadPersonalSavingImg,
  UploadTaxClearanceImg: uploadTaxClearanceImg,
  UploadSignatureImg: uploadSignatureImg,
  DeleteUploadImg: deleteUploadImg,
  DeleteTaxClearanceUploadImg: deleteTaxClearanceUploadImg,
  DeleteSigUrlUploadImg: deleteSigUrlUploadImg,
  PostKycRequest: postKycRequest,
  DeleteKycError: deleteKycError,
})(KycComponent));
